<div class="row m-0 prequal-info d-block" *ngIf="!showConfirmation">
  <ngx-ui-loader [loaderId]="'ContactStoreLoader'" class="noBackButton"> </ngx-ui-loader>
  <h1 class="col-12  p-0 prequal-title text-secondary-dark">{{SCData?.ContactStoreTitle}}</h1>
  <h3 class="col-12 p-0 prequal-message"> {{SCData?.ContactStoreSubtitle}} </h3>
  <div class="secure-text-box px-0">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon" clip-path="url(#clip0_225_674)">
        <g id="Lock">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M2.5 5.87921C2.15482 5.87921 1.875 6.15903 1.875 6.50421V10.0042C1.875 10.3494 2.15482 10.6292 2.5 10.6292H9.5C9.84518 10.6292 10.125 10.3494 10.125 10.0042V6.50421C10.125 6.15903 9.84518 5.87921 9.5 5.87921H2.5ZM1.125 6.50421C1.125 5.74482 1.74061 5.12921 2.5 5.12921H9.5C10.2594 5.12921 10.875 5.74482 10.875 6.50421V10.0042C10.875 10.7636 10.2594 11.3792 9.5 11.3792H2.5C1.74061 11.3792 1.125 10.7636 1.125 10.0042V6.50421Z"
            fill="black" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6 1.37921C5.43641 1.37921 4.89591 1.60309 4.4974 2.00161C4.09888 2.40012 3.875 2.94063 3.875 3.50421V5.50421C3.875 5.71132 3.70711 5.87921 3.5 5.87921C3.29289 5.87921 3.125 5.71132 3.125 5.50421V3.50421C3.125 2.74171 3.4279 2.01045 3.96707 1.47128C4.50624 0.932112 5.2375 0.629211 6 0.629211C6.7625 0.629211 7.49376 0.932112 8.03293 1.47128C8.5721 2.01045 8.875 2.74171 8.875 3.50421V5.50421C8.875 5.71132 8.70711 5.87921 8.5 5.87921C8.29289 5.87921 8.125 5.71132 8.125 5.50421V3.50421C8.125 2.94063 7.90112 2.40012 7.5026 2.00161C7.10409 1.60309 6.56359 1.37921 6 1.37921Z"
            fill="black" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_225_674">
          <rect width="12" height="12" fill="white" transform="translate(0 0.00421143)" />
        </clipPath>
      </defs>
    </svg>

    <span class="secure-text-msg">{{SCData?.SecurelyText}}</span>
  </div>

  <form novalidate [formGroup]="preQualForm" class="col-12 p-0 scrollDiv prequalForm">
    <div class="row m-0 preQualFormRow">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 rail leftRail px-0">
        <!-- Start if First Name-->
        <div class="row mx-0 form-row w-100">
          <div class="col-8 pr-3">
            <label class="text-dark-gray"
              for="first_name">{{ SCData?.FirstName }}<span aria-hidden="true" class="asterisk-pink">*</span></label>
            <input id="first_name" class="form-control w-100" formControlName="FirstName" maxlength="32" type="text"
              autocomplete="first_name" (click)="reportFormStart()" (focus)="preQualForm.get('FirstName').markAsUntouched();firstname.focus()"
              #firstname [ngClass]="{
                error:
                  (preQualForm.get('FirstName').touched ||
                    preQualForm.get('FirstName').dirty) &&
                  !preQualForm.get('FirstName').valid
              }" />
            <div class="invalid-feedback error-width-for-half-row d-flex"
              (click)="preQualForm.get('FirstName').markAsUntouched();firstname.focus()"
              *ngIf="!hasFocus(firstname) && preQualForm.get('FirstName').touched  && !preQualForm.get('FirstName').valid">
              <span class="form-validator_error" role="alert">
                <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.required; else second">
                  {{ SCData?.FirstNameRequiredError }}
                </ng-container>
                <ng-template #second>
                  <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.minlength; else third">
                    {{ SCData?.FirstNameInvalidError }}
                  </ng-container>
                  <ng-template #third>
                    <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.pattern">
                      {{ SCData?.FirstNameInvalidError }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </span>
            </div>
          </div>

          <div class="col-4">
            <label class="an-p-line-height" for="MiddleName" class="mi-label" autocomplete="additional-name"
              aria-label="Middle Name (Optional)">{{SCData?.MiddleName}}</label>
            <input class="form-control w-100" name="MI" formControlName="MI" maxlength="1" type="text" #mi
            (click)="reportFormStart()" id="MiddleName" [ngClass]="{
                error:
                  (preQualForm.get('MI').touched ||
                  preQualForm.get('MI').dirty) &&
                  !preQualForm.get('MI').valid
              }" />
            <div class="invalid-feedback d-flex" (click)="preQualForm.get('MI').markAsUntouched();mi.focus()"
              *ngIf="!hasFocus(mi) && preQualForm.get('MI').touched  && !preQualForm.get('MI').valid">
              <span class="form-validator_error" role="alert">
                <ng-container *ngIf="!!preQualForm.get('MI').errors?.required; else second">
                  {{ SCData?.MIInvalid }}
                </ng-container>
                <ng-template #second>
                  <ng-container *ngIf="!!preQualForm.get('MI').errors?.minlength; else third">
                    {{ SCData?.MIInvalid }}
                  </ng-container>
                  <ng-template #third>
                    <ng-container *ngIf="!!preQualForm.get('MI').errors?.pattern">
                      {{ SCData?.MIInvalid }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </span>
            </div>
          </div>

        </div>
        <!-- end of First name and Start of Last Name-->
        <div class="row mx-0 form-row w-100">
          <div class="col-12">
            <label class="text-dark-gray" for="lastNameId">{{ SCData?.LastName }}<span aria-hidden="true"
                class="asterisk-pink">*</span></label>
            <input class="form-control w-100 pr-5" maxlength="65" id="lastNameId"
            (click)="reportFormStart()" (focus)="preQualForm.get('LastName').markAsUntouched();lastname.focus()" type="text"
              autocomplete="family-name" formControlName="LastName" #lastname [ngClass]="{
                error:
                  (preQualForm.get('LastName').touched ||
                    preQualForm.get('LastName').dirty) &&
                  !preQualForm.get('LastName').valid
              }" />

            <div class="invalid-feedback error-width-for-full-row d-flex"
              (click)="preQualForm.get('LastName').markAsUntouched();lastname.focus()"
              *ngIf="!hasFocus(lastname) && preQualForm.get('LastName').touched  && !preQualForm.get('LastName').valid">
              <span class="form-validator_error" role="alert">
                <ng-container *ngIf="!!preQualForm.get('LastName').errors?.required; else second">
                  {{ SCData?.LastNameRequiredError }}
                </ng-container>
                <ng-template #second>
                  <ng-container *ngIf="!!preQualForm.get('LastName').errors?.minlength; else third">
                    {{ SCData?.LastNameInvalidError }}
                  </ng-container>
                  <ng-template #third>
                    <ng-container *ngIf="!!preQualForm.get('LastName').errors?.pattern">
                      {{ SCData?.LastNameInvalidError }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </span>
            </div>
          </div>
        </div>
        <!--end of last name and start of last name-->
        <div class="row mx-0 form-row w-100">
          <div class="col-12">
            <label class="text-dark-gray" for="email">{{ SCData?.Email }}<span aria-hidden="true"
                class="asterisk-pink">*</span>
              <span class="email-tooltip" *ngIf="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email">
                <span class="feature-text" id="emailTooltip-Content">
                  <span class="tooltiptext" id="emailTooltip">Forms submitted while you are logged in are tied to your
                    account. If you would like to change the email address used in this form, please log out and try
                    again.</span>
                  <span class="tooltipx dt-icon dt-icon-question-mark vhtooltip-style"></span>
                </span>
              </span>
            </label>
            <input class="form-control w-100 pr-2" type="text" formControlName="Email" id="email" autocomplete="email"
            (click)="reportFormStart()" (focus)="preQualForm.get('Email').markAsUntouched();email.focus()" maxlength="40" #email [ngClass]="{
                error:
                  (preQualForm.get('Email').touched ||
                    preQualForm.get('Email').dirty) &&
                  !preQualForm.get('Email').valid
              }" [attr.disabled]="disableEmailFieldFn"
              [readonly]="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email" />
            <div class="invalid-feedback error-width-for-full-row d-flex"
              (click)="preQualForm.get('Email').markAsUntouched();email.focus()"
              *ngIf="!hasFocus(email) && preQualForm.get('Email').touched  && !preQualForm.get('Email').valid">
              <span class="form-validator_error" role="alert">
                <ng-container *ngIf="!!preQualForm.get('Email').errors?.required; else second">
                  {{ SCData?.EmailRequiredError }}
                </ng-container>
                <ng-template #second>
                  <ng-container *ngIf="preQualForm.get('Email').errors?.apiInvalid; else third">
                    {{ preQualForm.get('Email').errors?.apiInvalid?.message || 'Please use a valid email.' }}
                  </ng-container>
                  <ng-template #third>
                    <ng-container *ngIf="!preQualForm.get('Email').valid">
                      {{ SCData?.EmailInvalidError }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </span>
            </div>
          </div>
        </div>
        <!--end of Email and start if phone and zipcode-->
        <div class="row mx-0 form-row w-100">
          <div class="col-8 pr-3">
            <label class="text-dark-gray" for="phone">{{ SCData?.Phone }}<span aria-hidden="true"
                class="asterisk-pink">*</span></label>
            <input class="form-control w-100" formControlName="Phone" id="phone" autocomplete="phone" #phone
            (click)="reportFormStart()" (focus)="preQualForm.get('Phone').markAsUntouched();phone.focus()" type="text" placeholder="(___)___-____"
              [dtTextMask]="{ mask: phoneMask, guide: true }" [ngClass]="{
                error:
                  (preQualForm.get('Phone').touched ||
                    preQualForm.get('Phone').dirty) &&
                  (!!preQualForm.get('Phone').invalid || !!preQualForm.get('Phone').errors?.invalidAreaCode)
              }" />
            <div class="invalid-feedback error-width-for-half-row d-flex"
              (click)="preQualForm.get('Phone').markAsUntouched();phone.focus()"
              *ngIf="!hasFocus(phone) && preQualForm.get('Phone').touched  && !preQualForm.get('Phone').valid">
              <span class="form-validator_error" role="alert">
                <ng-container *ngIf="!!preQualForm.get('Phone').errors?.required; else second">
                  {{ SCData?.PhoneRequiredError }}
                </ng-container>
                <ng-template #second>
                    <ng-container *ngIf="preQualForm.get('Phone').errors?.invalidAreaCode; else third">
                      {{ SCData?.PhoneInvalidAreaCode }}
                    </ng-container>
                  </ng-template>
                  <ng-template #third>
                    <ng-container *ngIf="preQualForm.get('Phone').errors?.apiInvalid; else fourth">
                      {{ preQualForm.get('Phone').errors?.apiInvalid?.message || 'Please use a valid phone number.' }}
                    </ng-container>
                    <ng-template #fourth>
                      <ng-container *ngIf="!preQualForm.get('Phone').valid">
                        {{ SCData?.PhoneInvalidError }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
              </span>
            </div>
          </div>

          <div class="col-4">
            <label class="text-dark-gray" for="zip_code">{{ SCData?.Zipcode }}<span aria-hidden="true"
                class="asterisk-pink">*</span></label>
            <div class="mr-lg-0">
              <input class="form-control w-100 pr-5" id="zip_code" autocomplete="postal-code" #Zipcode
              (click)="reportFormStart()" (focus)="preQualForm.get('Zipcode').markAsUntouched();Zipcode.focus()" formControlName="Zipcode"
                [ngClass]="{'error': !preQualForm.get('Zipcode').valid &&
                          (preQualForm.get('Zipcode').touched ||
                          preQualForm.get('Zipcode').dirty ||
                          (formSubmitAttempt)) }" type="text" [dtTextMask]="{ mask: zipCodeMask, guide:false }" />

              <div class="invalid-feedback error-width-for-half-row d-flex"
                (click)="preQualForm.get('Zipcode').markAsUntouched();Zipcode.focus()"
                *ngIf="!hasFocus(Zipcode) && preQualForm.get('Zipcode').touched  && !preQualForm.get('Zipcode').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('Zipcode').errors?.required; else second">
                    {{ SCData?.ZipCodeRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!preQualForm.get('Zipcode').valid">
                      {{ SCData?.ZipCodeInvalidError }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </form>

  <div class="col-12 p-0 d-flex cta-col">
    <button id="back_cta" type="button" [disabled]="!preQualForm.valid" class="primary-cta ml-auto" (click)="submitPreQualApplication()">
      {{ SCData?.ContactStoreSubmit}}
    </button>
  </div>

</div>

<div class="row m-0 confirmation" *ngIf="showConfirmation">
  <div class="col">
    <div class="confirmation-container d-flex justify-content-center w-100 align-items-center h-100 w-100 flex-wrap" >
      <div class="confirmation-icon d-flex justify-content-center w-100">
        <img [src]="SCData?.ConfirmationLogo" />
      </div>
      <div class="confirmationTitle d-flex justify-content-center w-100">{{SCData?.ConfirmationTitle}}</div>
      <div class="confirmationSubTitle d-flex justify-content-center w-100">{{SCData?.ConfirmationSubTitle}}</div>
    </div>
  </div>
</div>

<div class="dt-modal" tabindex="-1" role="dialog" *ngIf="showJackedModal" (click)="closeJacked()">
  <div class="dt-modal-dialog pqrj" role="document">
    <div class="dt-modal-content">
      <div class="close-modal " data-dismiss="modal">
        <div class="close-x" (click)="closeJacked()">
          <img type="image/svg+xml" alt="close"
            src="data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2017%2017%22%3Ea%20%20%3Cdefs%3E%20%3Cstyle%3E.clsa%2C.clsc%7Bfill%3A%230A3453%3B%7D.clsa%7Bclip-rule%3Aevenodd%3B%7D.clsb%7Bclip-path%3Aurl%28%23clsa%29%3B%7D.clsd%7Bclip-path%3Aurl%28%23clsb%29%3B%7D%20%3C%2Fstyle%3E%20%3CclipPath%20id%3D%22clsa%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M1.495-16.278%2C17.722-.051l-.773.773L.722-15.505Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%3CclipPath%20id%3D%22clsb%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M16.949-16.278l.773.773L1.495.722.722-.051Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20transform%3D%22translate%28-0.722%2016.278%29%22%3E%20%3Cg%20class%3D%22clsb%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M2.151-23.349%2C26.105.605l-8.5%2C8.5L-6.349-14.849Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%3Cg%20class%3D%22clsd%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M17.605-23.349l8.5%2C8.5L2.151%2C9.105l-8.5-8.5Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%20%3C%2Fsvg%3E">
        </div>
      </div>
      <div class="modal-body">
        <div class="jacked-body row">
          <span class="jacked-image"><img [src]="SCData?.JackedImage" alt="Something Jacked up" /></span>
          <span class="jacked-title an-h-line-height">{{ SCData?.JackedTitle }}</span>
          <span class="jacked-subtitle an-p-line-height">{{ SCData?.JackedMessage }} </span>
          <span class="jacked-buttons">
            <button class="secondary-cta ml-auto" (click)="closeJacked()">{{ SCData?.JackedCTA }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
